import { motion } from "framer-motion";

interface IntroSlideProps {
  firstName: string;
}

const IntroSlide = ({ firstName }: IntroSlideProps) => {
  return (
    <div className="flex flex-col items-center justify-center text-center px-6">
      {/* Animated Nimi Logo */}
      <motion.div
        initial={{ scale: 0, rotate: -180 }}
        animate={{ scale: 1, rotate: 0 }}
        transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
        className="mb-8 relative"
      >
        <motion.img
          src="/lovable-uploads/cee94e78-b677-411d-9ba5-f432a1142eac.png"
          alt="Nimi"
          className="h-20 brightness-200"
        />
        <motion.div
          className="absolute inset-0"
          animate={{
            scale: [1, 1.15, 1],
            opacity: [0.5, 1, 0.5],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          <img
            src="/lovable-uploads/cee94e78-b677-411d-9ba5-f432a1142eac.png"
            alt=""
            className="h-20 brightness-200 opacity-50"
          />
        </motion.div>
      </motion.div>

      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
        className="text-4xl md:text-5xl font-bold text-background mb-4"
      >
        Hey {firstName}!
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6 }}
        className="text-xl text-background/80 mb-8"
      >
        Let's look back at your
      </motion.p>

      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.8, type: "spring" }}
        className="relative"
      >
        <h2 className="text-5xl md:text-7xl font-bold text-secondary">
          2025
        </h2>
        <motion.span
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 1.2 }}
          className="block text-2xl md:text-3xl text-background mt-2"
        >
          Year in Art
        </motion.span>
      </motion.div>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.6 }}
        className="mt-12 text-sm text-background/60"
      >
        Tap anywhere to continue
      </motion.p>
    </div>
  );
};

export default IntroSlide;
